"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (props) {
    return React.createElement("div", { className: styles.content }, props.children);
};

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var styles = require("./Content.less");
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Content.tsx
 ** module id = 1302
 ** module chunks = 0
 **/